import { createSlice } from "@reduxjs/toolkit";
import {
  addSubTopic,
  updateSubTopic, 
  deleteSubTopic, 
  activateDeactivateSubTopic, 
  uploadSubTopicImageIcon, 
  fetchSubTopicTableColumnNames,
  fetchAllSubTopics,
  fetchTopics,
} from "./thunk";
import { toast } from "react-toastify";

const subTopicSlice = createSlice({
  name: "subtopics",
  initialState: {
    subTopics: [], 
    topics: [], 
    tableColumnNames: [], // This is for SubTopic table columns
    uploadedImageUrl: null,
    loading: false,
    headerload: false,
    imageload: false,
    error: null,
  },
  reducers: {
    clearUploadedSubTopicImageUrl: (state) => {
      state.uploadedImageUrl = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Topic Table Column Names
      .addCase(fetchSubTopicTableColumnNames.pending, (state) => {
        state.headerload = true;
        state.error = null;
      })
      .addCase(fetchSubTopicTableColumnNames.fulfilled, (state, action) => {
        state.headerload = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchSubTopicTableColumnNames.rejected, (state, action) => {
        state.headerload = false;
        state.error = action.payload;
      })

      // Fetch Topics
      .addCase(fetchAllSubTopics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllSubTopics.fulfilled, (state, action) => {        
        state.loading = false;
        state.subTopics = action.payload;
      })
      .addCase(fetchAllSubTopics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add SubTopic
      .addCase(addSubTopic.pending, (state) => {
        state.error = null;
      })
      .addCase(addSubTopic.fulfilled, (state, action) => {
        state.subTopics.unshift(action.payload[0]); 
      })
      .addCase(addSubTopic.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update SubTopic
      .addCase(updateSubTopic.pending, (state) => {
        state.error = null;
      })
      .addCase(updateSubTopic.fulfilled, (state, action) => {
        const updatedSubTopic = action.payload[0];
        const index = state.subTopics.findIndex(t => t.ID === updatedSubTopic.ID); 
        if (index !== -1) {
          state.subTopics[index] = updatedSubTopic;
        }
      })
      .addCase(updateSubTopic.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete SubTopics
      .addCase(deleteSubTopic.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteSubTopic.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.subTopics = state.subTopics.filter((item) => !deletedIds.includes(item.ID));
      })
      .addCase(deleteSubTopic.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Activate/Deactivate SubTopic
      .addCase(activateDeactivateSubTopic.pending, (state) => {
        // No loading indicator for toggle, or a very subtle one if preferred
        state.error = null;
      })
      .addCase(activateDeactivateSubTopic.fulfilled, (state, action) => {
        const updatedSubTopic = Array.isArray(action.payload) ? action.payload[0] : action.payload;
        const index = state.subTopics.findIndex(t => t.ID === updatedSubTopic?.ID); 
        
        if (index !== -1) {
          state.subTopics[index] = { ...state.subTopics[index], ...updatedSubTopic };
        }
      })
      .addCase(activateDeactivateSubTopic.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Upload SubTopic Image Icon
      .addCase(uploadSubTopicImageIcon.pending, (state) => { 
        state.imageload = true;
        state.error = null;
      })
      .addCase(uploadSubTopicImageIcon.fulfilled, (state, action) => {
        state.imageload = false;
        state.uploadedImageUrl = action.payload; 
      })
      .addCase(uploadSubTopicImageIcon.rejected, (state, action) => {
        state.imageload = false;
        state.error = action.payload;
      })
  },
});

export const { clearUploadedSubTopicImageUrl } = subTopicSlice.actions; // Corrected from topicSlice.actions
export default subTopicSlice.reducer;
